<template>
  <div class="basic_image_material" style="position: relative">
    <div class="content">
      <div class="title">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-haibaoxinxi16"></use>
        </svg>
        {{$route.query.channelType == '4'? '二维码':'用户头像22'}}
      </div>
      <div class="img codeImg" @click="add_module(imgCodeData,'qrCode')" v-if="$route.query.channelType == '4'">
        <img src="https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp" alt="" />
        <div class="codehover">
            职位二维码
        </div>
      </div>
      <div v-else class="img" @click="add_module(imgData,'userProfile')">
        <img src="/img/poster/avatar.svg" alt="" />
      </div>
    </div>
    <div class="content">
      <div class="title">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-haibaoxinxi16"></use>
        </svg>
        上传图片
      </div>
        <el-tooltip
        class="item"
        content="图片大小不得超过5M，支持文件类型为png，jpg，jpeg，建议尺寸：750*1220px。"
        placement="top-end"
        >
            <div slot="content" class="content" style="width:300px">图片大小不得超过5M，支持文件类型为png，jpg，jpeg，图片长宽比为4:3，建议尺寸320px*240px。</div>
            <Upload
                ref="uploadRef"
                type="img"
                :allowType ="acceptType"
                :allowSize="5*1024"
                :limit="1"
                :showFileList="false"
                @uploadSuccess="uploadSuccess">
            </Upload>
        </el-tooltip>
    </div>
    <el-button
      type="primary"
      style="z-index: 9999; position: absolute; left: 0; bottom: 10px; width: 100%"
      v-if="$store.state.widgets.replace_img_type === 'pictures'"
      @click="picturesConfirm"
    >
      确定
    </el-button>
  </div>
</template>

<script type="text/javascript">
import defstyle from './style.js'
import Upload from '@/components/upload'
export default {
  name: 'BasicImageMaterial',
  data() {
    return {
      isShowType: true,
      isShow: false,
      selecIndex: 0,
      // 展示所有分类名称
      alllistTypeName: '',
      fileType: 'SYSFILE_CLASS_IMAGE',
      activeName: 'all_gallery',
      cateImgLists: [],
      // cateListsMore: [],
      ismore: false,
      imgLists: [],
      imageList: [],
      now_cate: 'all',
      img_loading: false,
      my_loading: false,
      up_choose_num: 0,
      upfile_num: 0,
      totalLength: 0, // 成功
      formatLength: 0, // 格式
      sizeLength: 0, // 大小
      pxLength: 0, // 尺寸
      total: 0,
      filetotal: 0,
      folderfiletotalarr: [],
      listQuery: {
        fileType: 'SYSFILE_CLASS_IMAGE',
        pageNum: 1,
        pageSize: 20
      },
      folderQuery: {
        folderId: 0,
        fileName: '',
        pageNum: 1,
        pageSize: 20,
        fileType: 1,
        fileSource: 'sc',
        fileSourceC: 1
      },
      finished: false,
      my_finished: false,
      folder_finished: false,
      fileSeled: [], // 选中图片
      folderSeled: [], // 选中文件夹
      // 文件夹列表
      folderList: [],
      // 图片列表
      fileList: [],
      folderimg: [],
      folder_id: 0,
      folder_name: '',
      is_edit: false, // 显示管理
      checked: false, // 全选
      edit_folder: {
        index: '',
        name: '',
        id: ''
      },
      acceptfiles: '.png,.jpg,.jpeg,.gif,.webp',
      collectionList: [],
      collection_loading: false,
      collection_finished: false,
      collection_page: 1,
      pictures: [], // 组图组件选中的图片
      dragFlag: false, // 是否有拖拽进来
      needMinus: 0, // 需要减去的数
      imgData: {
        fileId: null,
        fileName: '194ff5a8-4346-4dfa-bf49-6008531520b9-8321.png',
        fileType: 'SYSFILE_CLASS_IMAGE',
        flag: 'N',
        id: '1640595512911011',
        materialTypeId: '1640239610601007',
        thumbnailUrl: '/img/poster/avatar.svg',
        typeName: '卡通'
      },
      imgCodeData: {
        fileId: null,
        fileName: '194ff5a8-4346-4dfa-bf49-6008531520b9-8321.png',
        fileType: 'SYSFILE_CLASS_IMAGE',
        flag: 'N',
        id: '1640595512911011',
        materialTypeId: '1640239610601007',
        thumbnailUrl: 'https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp',
        typeName: '职位二维码'
      },
      acceptType: ['.jpg', '.png', '.JPG', '.PNG', '.jpeg', '.JPEG']
    }
  },
  props: {},
  computed: {
    module() {
      return this.$store.state.widgets.module_Data
    },
    disabled() {
      return this.img_loading || this.finished
    },
    my_disabled() {
      return this.my_loading || this.my_finished
    },
    folder_disabled() {
      return this.my_loading || this.folder_finished
    },
    current_page_index() {
      return this.$store.state.body.current_page_index
    },
    pages() {
      return this.$store.state.body.data.pages
    },
    page() {
      let end = {}
      const now_page = this.pages
      if (now_page) end = now_page
      return end
    },
    uploadDisabled() {
      return this.$store.state.widgets.demonstrationTag
    },
    typeList() {
      const typeNaleList = []
      const typeList = {}
      if (this.cateImgLists) {
        this.cateImgLists.forEach(item => {
          if (typeNaleList.indexOf(item.typeName) === -1) {
            typeNaleList.push(item.typeName)
            typeList[item.typeName] = [item]
          } else {
            typeList[item.typeName].push(item)
          }
        })
      }
      return typeList
    },
    tokenKey() {
      // 判断当前是什么模式并且有没有X-Token，浏览器可能存在X-Token，在设计师身份下，不应该用X-Token
      if (this.$store.state.widgets.role === 'template') {
        return 'SSO-X-Token'
      } else {
        return ''
      }
    },
  },
  watch: {
    'module.pictures': {
      handler() {
        if (this.$store.state.widgets.replace_img_type === 'pictures') {
          this.pictures = [...this.module.pictures]
        }
      },
      deep: true
    }
  },
  activated() {
    if (this.$store.state.widgets.replace_img_type === 'pictures') {
      this.pictures = [...this.module.pictures]
    }
  },
  methods: {
    uploadSuccess(res, file) {
      console.log(res, 'ss')
      this.getImg(res)
    },
    getImg(file, fileList) {
      const params = {
        fileId: null,
        fileName: '194ff5a8-4346-4dfa-bf49-6008531520b9-8321.png',
        fileType: 'SYSFILE_CLASS_IMAGE',
        flag: 'N',
        id: '1640595512911011',
        materialTypeId: '1640239610601007',
        thumbnailUrl: file.path,
        typeName: '图片'
      }
      this.add_module(params, 'img')
    },
    getBase64(file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      return new Promise(resolve => {
        reader.onload = () => {
          resolve(reader.result)
        }
      })
    },
    getImgPx(src) {
      const image = new Image()
      image.src = src
      return new Promise(resolve => {
        image.onload = () => {
          const width = image.width
          const height = image.height
          resolve({ width, height })
        }
      })
    },
    beforeUpload(file) {
      let type = file.name.substring(file.name.lastIndexOf('.') + 1)
      type = type.toLocaleLowerCase()
      // if (!~'image/png|image/jpg|image/jpeg|image/gif|image/webp'.indexOf(type)) {
      if (!~'image/png|image/jpg|image/jpeg|image/gif|image/webp'.indexOf(type)) {
        // this.$message('不支持的文件类型,仅支持以下类型:.jpeg,.jpg,.png,.gif,.webp')
        // this.up_choose_num--
        this.needMinus++
        this.formatLength++ // 格式
        return false
      } else if (file.size / 1024 / 1024 > 5) {
        // this.$message('图片大小不能超过5M');
        this.sizeLength++ // 大小
        // this.up_choose_num--
        this.needMinus++
        return false
      }
      return true
    },
    handleExceed(files) {
      this.$message.warning(`一次最多上传 10 个文件，本次选择了 ${files.length} 个文件`)
    },
    handFileChange(file, fileList) {
      if (file.status !== 'ready') return
      console.log(file, fileList)
      if (fileList.length > 0) {
        this.up_choose_num = fileList.length
        this.totalLength = fileList.length // 所有
        // this.formatLength = 0 // 格式
        // this.sizeLength = 0 // 大小
        // this.pxLength = 0 // 尺寸
      }
      // var upload_img = document.getElementsByClassName('eup-file')
      // if (upload_img && upload_img.length > 0) {
      //   var upload = upload_img[0].getElementsByTagName('input')
      //   if (upload && upload.length > 0 && upload[0].files && upload[0].files.length > 0) {
      //     this.up_choose_num = upload[0].files.length
      //     this.totalLength =upload[0].files.length;// 所有
      //     this.formatLength =0;// 格式
      //     this.sizeLength =0;// 大小
      //     this.pxLength =0;// 尺寸
      //   }
      // }
    },
    handfolderFileChange(file, fileList) {
      var upload_img = document.getElementsByClassName('eup-folderfile')
      if (upload_img && upload_img.length > 0) {
        var upload = upload_img[0].getElementsByTagName('input')
        if (upload && upload.length > 0 && upload[0].files && upload[0].files.length > 0) {
          this.up_choose_num = upload[0].files.length
          this.totalLength = upload[0].files.length // 所有
          this.formatLength = 0 // 格式
          this.sizeLength = 0 // 大小
          this.pxLength = 0 // 尺寸
        }
      }
    },
    convertImgToBase64(url, callback, format) {
      let outputFormat = 'image/' + format
      console.log('outputFormat', outputFormat)
      let canvas = document.createElement('CANVAS')
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.crossOrigin = 'Anonymous'
      const that = this
      img.onload = function() {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        outputFormat = outputFormat || 'image/png'
        // let dataURL = canvas.toDataURL(outputFormat)
        // let dataURL = canvas.toBlob(callback(outputFormat),outputFormat)
        const blob = that.converrVase64UrlToBlob(canvas.toDataURL(outputFormat), outputFormat)
        // console.log('dataURL',dataURL)
        const fileBlob = new File([blob], new Date().getTime() + '.' + format, { type: outputFormat })
        callback(fileBlob)
        canvas = null
      }

      img.src = url
    },
    // base64转Blob
    converrVase64UrlToBlob(base64, mimeType) {
      // mimeType 图片类型，例如 mimeType='image/png'
      const bytes = window.atob(base64.split(',')[1]) // atob方法用于解码base64
      // 创建一个长度为 bytes.length 的 buffer(一个二进制文件), 它会分配一个 16 字节（byte）的连续内存空间，并用 0 进行预填充。
      const ab = new ArrayBuffer(bytes.length)

      // Uint8Array —— 将 ArrayBuffer 中的每个字节视为 0 到 255 之间的单个数字（每个字节是 8 位）。这称为 “8 位无符号整数”。
      const ia = new Uint8Array(ab)
      for (let i = 0; i < bytes.length; i++) {
        // 更改里面的初始化内容
        ia[i] = bytes.charCodeAt(i)
      }
      // 创建blob格式数据，并传入二进制文件和文件原本类型
      return new Blob([ia], { type: mimeType })
    },
    add_module(item, type) {
    //   if (this.activeName === 'all_gallery') {
    //     window.collectEvent('Web_Editor_Image_ImageGallery_Use', {
    //       work_id: this.$store.state.widgets.theme_id,
    //       work_name: this.$store.state.widgets.theme_info.title,
    //       image_id: item.id
    //     })
    //   } else if (this.activeName === 'collection') {
    //     window.collectEvent('Web_Editor_Image_Collection_Use', {
    //       work_id: this.$store.state.widgets.theme_id,
    //       work_name: this.$store.state.widgets.theme_info.title,
    //       image_id: item.id
    //     })
    //   }
      const params = {
        file: {
          key: item.thumbnailUrl,
          filtereffect: 'original',
          a: null,
          server: '',
          orikey: item.thumbnailUrl
        }
      }
      if (this.$store.state.widgets.is_replace_img) {
        this.replace_img(params)
        return
      }
      this.create_img(params.file, type)
    },
    create_img(file, type) {
      const _defstyle = JSON.parse(JSON.stringify(defstyle))
      _defstyle.file = file
      this.load_img(file, img => {
        const w = ['userProfile', 'qrCode'].includes(type) ? 60 : 160
        let h = ['userProfile', 'qrCode'].includes(type)  ? 60 : 160
        const _w = img.naturalWidth
        const _h = img.naturalHeight
        h = _h * (w / _w)
        _defstyle.style.width = w
        _defstyle.style.height = Math.round(h)
        const PendantObj = this.$store.state.widgets.PendantObj
        const widgets = this.templet.get_widgets()
        _defstyle.name = PendantObj['image'].name + (widgets.length + 1)
        this.templet.add_module('image', _defstyle, false, type)
      })
    },
    picturesConfirm() {
      // 判断pictures是否为空
      if (this.pictures.length === 0) {
        this.$message.error('请选择图片')
        return
      }
      // 添加到modules
      this.module.pictures = [...this.pictures]
      this.$store.commit('app/set_is_replace_img', false)
      this.$store.commit('left_module_material/SET_is_show', false)
    },
    replace_img(params) {
      if (this.$store.state.widgets.replace_img_type === 'img') {
        this.replace_module_img(params)
        this.reset_widget_crop_data()
      } else if (this.$store.state.widgets.replace_img_type === 'lantern') {
        this.replace_lantern_image(params)
      } else if (this.$store.state.widgets.replace_img_type === 'wipe') {
        // 擦一擦
        this.module.image = params.file.key
        this.$store.commit('app/set_is_replace_img', false)
        this.$store.commit('left_module_material/SET_is_show', false)
      } else if (this.$store.state.widgets.replace_img_type === 'fingerprint_bg') {
        // 指纹开屏
        this.module.fingerprintBg = params.file.key
        this.$store.commit('app/set_is_replace_img', false)
        this.$store.commit('left_module_material/SET_is_show', false)
      } else if (this.$store.state.widgets.replace_img_type === 'fingerprint') {
        // 指纹开屏
        this.module.fingerprint = params.file.key
        this.$store.commit('app/set_is_replace_img', false)
        this.$store.commit('left_module_material/SET_is_show', false)
      } else if (this.$store.state.widgets.replace_img_type === 'pictures') {
        // 组图
        if (this.pictures.length === 6 && !this.pictures.includes(params.file.key)) {
          this.$message.error('最多只能添加6张图片')
        } else if (this.pictures.includes(params.file.key)) {
          // 存在的话删掉
          this.pictures.splice(this.pictures.indexOf(params.file.key), 1)
        } else {
          this.pictures.push(params.file.key)
        }
      } else if (this.$store.state.widgets.replace_img_type === 'qrcode') {
        // 二维码
        this.module.logoImg = params.file.key
        this.$store.commit('app/set_is_replace_img', false)
        this.$store.commit('left_module_material/SET_is_show', false)
      } else {
        // === 'page'
        this.replace_page_background(params)
        this.reset_page_crop_data()
      }
    },
    replace_page_background(params) {
      this.page.bgimage = params.file.key
    },
    replace_module_img(params) {
      this.handle_img_scale(params.file)
      this.$store.state.widgets.module_Data.file = params.file
      this.$store.commit('app/set_is_replace_img', false)
      this.$store.commit('left_module_material/SET_is_show', false)
    },
    reset_widget_crop_data() {
      this.$store.state.widgets.module_Data.crop = null
    },
    reset_page_crop_data() {
      this.page.crop = null
    },
    replace_lantern_image(params) {
      this.module.btnStyle['background-image'] = params.file.key
      this.$store.commit('app/set_is_replace_img', false)
      this.$store.commit('left_module_material/SET_is_show', false)
    },
    handle_img_scale(file) {
      this.load_img(file, img => {
        this.$store.state.widgets.module_Data.style.height =
          img.naturalHeight * (this.module.style.width / img.naturalWidth)
      })
    },
    load_img(file, cb) {
      const img = new Image()
      img.src = file.key
      img.onload = function() {
        cb && cb(img)
      }
    },
    handleClick(tab, event) {
      if (tab.name === 'collection') {
        window.collectEvent('Web_Editor_Image_Collection', {
          work_id: this.$store.state.widgets.theme_id,
          work_name: this.$store.state.widgets.theme_info.title
        })
        this.collection_finished = false
        this.collection_page = 1
        this.collectionList = []
        this.getCollectionList()
      } else if (tab.name === 'all_gallery') {
        window.collectEvent('Web_Editor_Image_ImageGallery', {
          work_id: this.$store.state.widgets.theme_id,
          work_name: this.$store.state.widgets.theme_info.title
        })
      } else if (tab.name === 'my_gallery') {
        window.collectEvent('Web_Editor_Image_MyImageGallery', {
          work_id: this.$store.state.widgets.theme_id,
          work_name: this.$store.state.widgets.theme_info.title
        })
      }
    },
    onClickCollectBtn(item, index) {
      if (item.flag === 'Y') {
        if (this.activeName === 'collection') {
          window.collectEvent('Web_Editor_Image_Collection_Unfavorite', {
            work_id: this.$store.state.widgets.theme_id,
            work_name: this.$store.state.widgets.theme_info.title,
            image_id: item.id
          })
        } else {
          window.collectEvent('Web_Editor_Image_ImageGallery_Unfavorite', {
            work_id: this.$store.state.widgets.theme_id,
            work_name: this.$store.state.widgets.theme_info.title,
            image_id: item.id
          })
        }
      } else {
        window.collectEvent('Web_Editor_Image_ImageGallery_Collect', {
          work_id: this.$store.state.widgets.theme_id,
          work_name: this.$store.state.widgets.theme_info.title,
          image_id: item.id
        })
      }
    },
    backList() {
      this.isShowType = true
      this.getCategoryList()
    },
    switchCate(typeName, imgList) {
      this.alllistTypeName = typeName
      this.isShowType = false
      imgList.forEach(el => {
        // console.log(el, 'el')
        window.collectEvent('Web_Editor_Image_ImageGallery_Filter', {
          filter_id: el.materialTypeId ? el.materialTypeId : 'all',
          filter_name: el.materialTypeId ? el.typeName : '全部'
        })
      })
      // this.selecIndex = index
      // let id = item.id
      // window.collectEvent('Web_Editor_Image_ImageGallery_Filter', {
      //   filter_id: id ? id : 'all',
      //   filter_name: id ? item.typeName : '全部'
      // })
      this.now_cate = typeName
      this.finished = false
      this.listQuery.pageNum = 1
      this.imageList = []
      this.getSourceList()
    },
    getSourceList() {
      // console.log('触发了');
      this.img_loading = true
    },
    getCollectionList(option = {}) {
      if (this.collection_finished) {
        return
      }
    //   const isRefetchByDelete = option.isRefetchByDelete
    //   this.collection_loading = isRefetchByDelete ? false : true
    },
    getCategoryList() {
      this.img_loading = true
      // this.img_loading = true
      // categoryList({ fileType: 'SYSFILE_CLASS_IMAGE' })
      //   .then(res => {
      //     if (res.code === 200) {
      //       this.cateLists = res.data
      //       res.data.forEach((el, i) => {
      //         materialList({
      //           fileType: 'SYSFILE_CLASS_IMAGE',
      //           pageNum: 1,
      //           pageSize: 20,
      //           typeName: el.typeName
      //         }).then(res => {
      //           if (res.code === 200) {
      //             let datas = res.data
      //             ;(datas.list || []).forEach(item => {
      //               item.src = this.utils.src_has_gif(item.thumbnailUrl + '?w=150')
      //               item.errorSrc = item.thumbnailUrl + '?w=150'
      //             })
      //             if (datas.list.length <= 0) {
      //               this.imgLists[i] = 0
      //             } else {
      //               this.imgLists[i] = datas.list
      //             }
      //             this.total = datas.total
      //             setTimeout(() => {
      //               this.isShow = true
      //               this.img_loading = false
      //             }, 2000)
      //           } else {
      //             this.$message.error(res.message)
      //             this.img_loading = false
      //           }
      //         })
      //       })
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })
      //   .catch(err => {})
      //   .finally(() => {})
    },
    getFileList() {
      this.my_loading = true
    },
    getFolderList() {
      this.img_loading = true
    },
    getFolderimg() {
      const folder_id = this.folder_id
      this.folderQuery.folderId = folder_id
      this.my_loading = true
    },
    onClickTermsIcon() {
      this.$store.commit('app/SET_terms_dialog_visible', true)
      this.$store.commit('app/SET_terms_dialog_type', 'image')
    },
    onCollectionScrollBottom() {
      if (!this.collectionList.length) {
        return
      }
      this.getCollectionList()
    },
    onImgLoadError(item) {
      item.src = item.errorSrc
    },
    updateCollectionStatusInImgList(id, status) {
      const img = this.imgLists.find(item => item.id === id)
      img && (img.flag = 'N')
    }
  },
  created() {
    this.getCategoryList()
    this.getFileList()
    this.getFolderList()
  },
  mounted() {
    document.addEventListener('dragover', function(event) {
      event.preventDefault()
    })
    document.addEventListener('drop', function(event) {
      event.preventDefault()
    })
  },
  components: {
    Upload
  }
}
</script>

<style lang="scss" scoped>
.basic_image_material {
  height: 100%;
  color: #999999;
  padding: 16px 12px;
  ::v-deep .el-upload-dragger {
    width: 100%;
    height: 100%;
    border: none;
  }
  ::v-deep {
    .logo-uploader .el-upload{
        width: 68px;
        height: 68px;
        text-align: center;
        .logo-uploader-icon{
            line-height: 68px;
            width: 28px;
            height: 28px;
        }
    }
  }
  .content {
    .title {
      font-size: 14px;
      color: #1d2129;
      font-weight: 500;
      line-height: 40px;
      .icon {
        width: 16px;
        height: 16px;
        margin-right: 10px;
        vertical-align: -3px;
      }
    }
    .img {
      width: 70px;
      height: 70px;
      border: solid 1px #e5e6eb;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      img{
        width: 100%;
        height: 100%;
      }
      i{
        font-size: 70px;
      }
      &.codeImg{
        cursor: pointer;
        &:hover{
            .codehover{
                opacity: 1;
            }
        }
      }
      .codehover{
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;
        text-align: center;
        line-height: 18px;
        top: 0;
        opacity: 0;
        font-size: 12px;
        padding: 20px 15px 0;
      }
    }
  }

  .image-tabs {
    height: 100%;

    ::v-deep .el-tabs__header {
      margin-bottom: 0px;
    }

    ::v-deep .el-tabs__content {
      height: calc(100% - 79px);
    }
  }

  ::v-deep .el-tabs__nav-scroll {
    padding: 0px 24px;

    .el-tabs__item {
      color: #303133;
      height: 55px;
      line-height: 55px;
      padding-top: 5px;
    }

    .el-tabs__item.is-active {
      color: #0086ff;
    }
  }
  .tab_container {
    padding: 31px 0px 8px 24px;
    .img-item {
      height: 108px;
      .mark {
        height: 106px !important;
      }
    }
    .img-list {
      .el-image {
        width: 72px;
        height: 106px;
      }
    }
  }

  .tab_container,
  .tab_list_con {
    // padding: 31px 24px 8px 24px;
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
    // 滚动条兼容火狐
    scrollbar-color: rgba(187, 190, 202, 0.7); /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
    scrollbar-width: thin; /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
    -ms-overflow-style: none; /* 隐藏滚动条（在IE和Edge两个浏览器中很难更改样式，固采取隐藏方式） */
    &::-webkit-scrollbar {
      width: 6px; /*滚动条宽度*/
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px; /*滚动条的圆角*/
      background-color: rgba(187, 190, 202, 0.7); /*滚动条的背景颜色*/
    }

    .cate-list {
      display: flex;
      flex-wrap: wrap;
      font-size: 14px;
      margin-bottom: 5px;
      margin-left: -12px;
      margin-right: -12px;

      span {
        height: 20px;
        line-height: 20px;
        margin-bottom: 16px;
        cursor: pointer;
        padding-left: 12px;
        padding-right: 12px;
      }

      span.is-active,
      span:hover {
        font-weight: 500;
        color: #0086ff;
      }
    }
    .type_title {
      .type_text {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        font-size: 14px;
        margin-bottom: 12px;
      }
      .allList {
        cursor: pointer;
        color: #999;
      }
    }
    .type_title.isShowName {
      display: none;
    }

    .cate-list-more {
      position: relative;

      .more-span {
        cursor: pointer;
        padding-right: 0px;

        .el-icon-arrow-down {
          display: inline-block;
          transition: transform 0.3s;
          font-size: 12px;

          &.active {
            transform: rotate(180deg);
          }
        }
      }

      .cate-list {
        display: flex;
        position: absolute;
        top: 36px;
        right: -14px;
        width: 286px;
        background: #fff;
        z-index: 9999;
      }

      &:hover {
        .more-span {
          font-weight: 500;
          color: #0086ff;
        }
      }
    }

    .manage-btn {
      display: flex;
      margin-top: -9px;
      margin-bottom: 11px;

      .btn-a {
        width: 122px;
        font-size: 13px;
      }

      .btn-m {
        width: 122px;
        font-size: 13px;
      }
    }

    .manage-btn-edit {
      width: 300px;
      height: 48px;
      color: #fff;
      font-size: 12px;
      background: rgb(52, 140, 255);
      margin-left: -24px;
      margin-top: -30px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      padding-left: 25px;
      padding-right: 17px;
      position: relative;

      .checkbox-all {
        display: flex;
        align-items: center;
        font-size: 12px;
        cursor: pointer;

        .btn-all {
          width: 15px;
          height: 15px;
          margin-right: 4px;
          margin-bottom: 2px;
        }
      }

      .move-sel {
        cursor: pointer;
        margin-left: 33px;
        width: 70px;
        color: #fff;
        font-size: 12px;

        span {
          display: inline-block;
          width: 100%;
        }
      }

      .del-all {
        position: absolute;
        right: 80px;
        cursor: pointer;

        .el-icon-delete {
          margin-right: 3px;
        }
      }

      .close-btn {
        position: absolute;
        right: 17px;
        font-size: 16px;
        cursor: pointer;
      }
    }

    .manage-btn-folder-edit {
      width: 300px;
      height: 48px;
      background: #ffffff;
      box-shadow: 0px 1px 0px 0px #e2e8f0;
      font-size: 12px;
      margin-left: -24px;
      margin-top: -30px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 25px;
      padding-right: 17px;
      position: relative;

      .folder-return {
        width: 17px;
        height: 15px;
        background-image: url('https://sitecdn.71360.com/static/suichuan/assets/ide/images/return.png');
        background-position: center center;
        background-repeat: no-repeat;
        cursor: pointer;
      }

      .folder-m {
        cursor: pointer;
      }
    }

    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .s-container {
      // width: 270px;
      .img-list {
        // width: 254px;

        .el-col {
          border-radius: 4px;
          // padding: 8px;
          margin-bottom: 16px;
        }

        .img-item {
          position: relative;
          border-radius: 4px;
          background: #f5f5f5;
          cursor: pointer;
          border: 1px solid transparent;
          cursor: pointer;
          .mark {
            display: none;
            position: absolute;
            top: 0;
            width: 73px;
            height: 73px;
            border-radius: 4px;
            background-color: #333;
            opacity: 0.3;
          }

          &:hover {
            //border-color: #3399ff;
            // background: #ebf5ff;
            .mark {
              display: block;
            }
          }

          &.active {
            border-color: #3399ff;
            background: #ebf5ff;
          }

          .checkbox-btn {
            position: absolute;
            left: 1px;
            top: 1px;
            width: 16px;
            height: 16px;
            background: #fff;
            border-radius: 2px;
            border: 1px solid #dae2eb;
            z-index: 1;

            &.btn-check {
              background-image: url('https://sitecdn.71360.com/static/suichuan/assets/ide/images/right-btn.svg');
              border: none;
            }
          }

          .edit-btn {
            position: absolute;
            right: 1px;
            top: 1px;
            width: 16px;
            height: 16px;
            background: rgba(255, 255, 255, 0.01);
            background-image: url('https://sitecdn.71360.com/static/suichuan/assets/ide/images/edit.png');
            background-position: center center;
            background-repeat: no-repeat;
          }

          &.folder-item {
            background-image: url('https://sitecdn.71360.com/static/suichuan/assets/ide/images/folder.png');
            // background-size: 154px 154px;
            background-position: center center;
            background-repeat: no-repeat;
          }

          .folder-name {
            position: absolute;
            bottom: 1px;
            width: 100%;
            font-size: 12px;
            color: #666666;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .upload-item {
          position: relative;
          border-radius: 4px;
          height: 108px;
          cursor: pointer;
          border: 1px solid #dae2eb;

          .upload-btn {
            width: 74px;
            height: 108px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .el-icon-circle-plus-outline {
              font-size: 21px;
              color: #348cff;
              margin-bottom: 4px;
            }

            .item-t {
              font-size: 12px;
              color: #666666;
              line-height: 17px;
              margin-top: 7px;
            }
          }

          &:hover {
            background: #ebf5ff;
            border-color: #3399ff;
          }
        }
      }
    }
    // .lis_con {
    // ::v-deep .el-scrollbar__bar.is-vertical>div {
    //   display: none;
    // }
    // }
    .img_none {
      display: none;
    }
    .no-more {
      text-align: center;
    }

    .no-data {
      height: 42px;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(44, 44, 44, 0.19);
      line-height: 42px;
      text-align: center;
      margin-top: 86px;
    }
  }
}

.add-folder-mod {
  ::v-deep .el-dialog {
    border-radius: 4px;
  }

  ::v-deep .el-dialog__header {
    .el-dialog__headerbtn {
      font-size: 24px;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 15px 27px;
  }

  ::v-deep .el-dialog__footer {
    padding: 13px 24px 24px;
  }

  .folder-span {
    font-size: 14px;
    color: #333333;
  }

  .folder-input {
    width: 229px;
  }

  .folder-footer {
    button {
      margin-left: 16px;
    }
  }
}

.manage-image-dropdown {
  ::v-deep .el-dropdown-menu__item {
    padding-right: 40px;

    .el-icon-folder {
      margin-right: 6px;
    }
  }
}

.no-data-tip {
  margin-top: 170px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 16px;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  span {
    padding-left: 20px;
  }
}
.allList_con {
  height: 100%;
  padding: 24px 0px 24px 24px;
  // height: calc(100% - 20px);
  .all_list_img {
    height: calc(100% - 20px);
  }
  .type_text {
    margin-bottom: 12px;
    cursor: pointer;
  }
  ::v-deep .el-scrollbar__bar.is-horizontal > div {
    display: none;
  }
}

// 图片库
.tab_list_con {
  .type_content {
    height: 100%;
    padding: 24px 17px 0 24px;
    overflow-y: auto;
    // 滚动条兼容火狐
    scrollbar-color: rgba(187, 190, 202, 0.7); /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
    scrollbar-width: thin; /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
    -ms-overflow-style: none; /* 隐藏滚动条（在IE和Edge两个浏览器中很难更改样式，固采取隐藏方式） */
    &::-webkit-scrollbar {
      width: 6px; /*滚动条宽度*/
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px; /*滚动条的圆角*/
      background-color: rgba(187, 190, 202, 0.7); /*滚动条的背景颜色*/
    }
    .img_box {
      margin-bottom: 24px;
      display: flex;
      .img-item {
        // flex: 0 0 33.33%;
        width: 73px;
        background-color: #f5f5f5;
        border-radius: 4px;
        margin: 0 17px 24px 0;
        // height: 73px;
        cursor: pointer;
        &:nth-last-child(1) {
          margin-right: 0;
        }
        ::v-deep .el-image {
          width: 73px;
          height: 73px;
          object-fit: cover;
        }
      }
    }
  }
  .img-item {
    height: 73px;
  }
  .img-list {
    .el-image {
      width: 73px;
      height: 73px;
      cursor: pointer;
    }
  }
}
// .activeList.tab_list_con {
//   overflow-y: hidden;
// }
.img_con_info {
  display: flex;
  .img_list_con {
    // flex: 0 0 33.33%;
    width: 73px;
    margin-right: 17px;
    margin-bottom: 24px;
    &:nth-last-child(1) {
      margin-right: 0;
    }
  }
  .img-item {
    width: 73px;
    height: 73px;
    margin: auto;
    background-color: #f5f5f5;
    .el-image {
      width: 73px;
      height: 73px;
    }
  }
}
</style>
